import api from "src/apis/api"

export async function fetchDocumentSettings() {
  const { data } = await api.get("/api/v1/document_settings")
  return data.config
}

export async function updateDocumentSettings(config) {
  const { data } = await api.patch("/api/v1/document_settings", { config })
  return data.config
}

export async function generateQuotation(payload) {
  // payload: { booking_id } OR { deal_id, unit_id, cost_sheet }
  const { data } = await api.post("/api/v1/collections/quotation", payload)
  return data
}
